import React, { useEffect, useState } from "react";
import {
  Box, Typography, Button, ToggleButtonGroup, ToggleButton, Chip, Card, CardContent,
  CardMedia, Grid,
  Paper,
  IconButton,
  InputBase,
} from "@mui/material";
import axios from "axios";
import BillDetails from "./BillDetails";
import { HugeiconsIcon } from "@hugeicons/react";
import { Add01Icon, Clock01Icon, Search01Icon, TradeDownIcon, TradeUpIcon } from "@hugeicons/core-free-icons";
import NewBill from "./NewBill";
import AddBillDetails from "./AddBillDetail";

const BillDashboard = () => {
  const [selectedBill, setSelectedBill] = useState(null);
  const [searchBill] = React.useState("");
  //   const [sortValue, setSortValue] = React.useState("recent");
  const [bills, setBills] = useState([]);
  const [sortAmount, setSortAmount] = useState("recent");
  const [openCategoryPopup, setOpenCategoryPopup] = useState(false);
  const [openBillDetails, setOpenBillDetails] = useState(false);
  const [selectedTracker, setSelectedTracker] = useState(null);

  const handleCardClick = (bill) => {
    setSelectedBill(bill);
  };

  const handleLRHChange = (event, newValue) => {
    if (newValue !== null) {
      setSortAmount(newValue);
    }
  };

  const getAmountValue = (amountStr) => Number(amountStr.replace("₹", ""));

  useEffect(() => {
    // axios.get("http://localhost:5000/bills")
    axios.get("http://127.0.0.1:8000/bills/get")
      .then((res) => setBills(res.data))
      .catch((err) => console.error("Error fetching bills:", err));
  }, []);


  const filteredBills = bills.filter((bill) =>
    String(bill.id).toLowerCase().includes(searchBill.toLowerCase()) ||
    String(bill.amount).toLowerCase().includes(searchBill.toLowerCase())
  );


  const recentBills = [...filteredBills].slice(-6).reverse();

  let displayedBills = [...filteredBills];

  if (sortAmount === "low") {
    displayedBills = displayedBills.filter((bill) => getAmountValue(bill.amount) < 5000);
  } else if (sortAmount === "high") {
    displayedBills = displayedBills.filter((bill) => getAmountValue(bill.amount) >= 5000);
  } else if (sortAmount === "recent") {
    displayedBills = displayedBills.reverse();
  }


  return (
    <Box sx={{ mt: 10, px: 2, minHeight: "100vh" }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 500, color: '#545860' }}>Recent Bills</Typography>
        <Paper
          component="form"
          sx={{
            p: "4px 8px",
            display: "flex",
            alignItems: "center",
            borderRadius: 100,
            width: { xs: 180, sm: 230 },
            boxShadow: 'none',
            bgcolor: '#fff',
          }}
        >
          <IconButton
            size="small"
            sx={{
              bgcolor: "#fff",
              borderRadius: "50%",
              p: 0.5,
              mr: 1,
            }}
          >
            <HugeiconsIcon icon={Search01Icon} size={20} />
          </IconButton>
          <InputBase
            placeholder="Search..."
            inputProps={{ "aria-label": "search" }}
            sx={{ fontSize: 14, flex: 1 }}
          />
        </Paper>
        <Button
          variant="text"
          sx={{ textTransform: 'none', color: "#1976d2", fontWeight: "500" }}
          onClick={() => setOpenCategoryPopup(true)}
        >
          <HugeiconsIcon icon={Add01Icon} color="#1976d2" size={15} fontWeight={600} style={{ marginRight: 6 }} />
          Add New Bill
        </Button>
        <NewBill
          open={openCategoryPopup}
          onClose={() => setOpenCategoryPopup(false)}
          onSuccess={(tracker) => {
            setSelectedTracker(tracker);
            setOpenCategoryPopup(false);
            setOpenBillDetails(true);
          }}
        />

        {/* Step 2: Bill Details */}
        <AddBillDetails
          open={openBillDetails}
          trackerId={selectedTracker?.id}
          onClose={() => setOpenBillDetails(false)}
          onSave={(billData) => {
            console.log("Bill saved:", billData);
            setBills((prevBills) => [billData, ...prevBills]);
            setOpenBillDetails(false);
          }}
        />
      </Box>
      {/* Bill Cards Section */}
      <Grid container spacing={2}>
        {recentBills.map((bill, index) => (
          <Grid
            item
            key={index}
            xs={12}
            sm={6}
            md={4}
            lg={2}
            xl={2}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Card
              key={bill.id}
              onClick={() => handleCardClick(bill)}
              sx={{
                width: "100%",
                maxWidth: 180,
                borderRadius: 2,
                boxShadow: 3,
                overflow: "hidden",
                position: "relative",
                cursor: 'pointer',
                border: '1px solid #ccc',
                padding: '5px',
                margin: '10px 0'
              }}
            >
              {/* Agar image hai to show karo warna "No Preview Image" */}
              {bill.img ? (
                <CardMedia
                  component="img"
                  image={bill.img}
                  height="100"
                  alt="Bill"
                />
              ) : (
                <Box
                  height={100}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  sx={{ bgcolor: "#f5f5f5" }}
                >
                  <Typography variant="caption" color="text.secondary">
                    No Preview Image
                  </Typography>
                </Box>
              )}

              {/* Agar tagLabel aur tagColor hai tabhi chip show ho */}
              {bill.tagLabel && bill.tagColor && (
                <Chip
                  label={bill.tagLabel}
                  sx={{
                    position: "absolute",
                    top: 95,
                    right: 8,
                    height: 22,
                    fontSize: 12,
                    backgroundColor: bill.tagColor,
                    color: "white",
                    borderRadius: "10px",
                  }}
                />
              )}

              <CardContent sx={{ p: 1.5 }}>
                <Typography variant="body2" fontWeight="bold">
                  Bill ID: {bill.id}
                </Typography>
                <Typography variant="body2" fontWeight="bold">
                  Amount: {bill.amount}
                </Typography>
              </CardContent>
            </Card>


            {selectedBill && (
              <BillDetails
                open={Boolean(selectedBill)}
                onClose={() => setSelectedBill(null)}
                bill={selectedBill}
              />
            )}
          </Grid>
        ))}
      </Grid>

      {/* <Box
        sx={{
          textAlign: "center",
          color: "#aaa",
          mt: 4,
          fontSize: 16,
          fontStyle: "italic",
        }}
      >
        Bill cards will be displayed here after API integration.
      </Box> */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={2}
        mb={3}
        mt={5}
      >
        <Typography fontSize={23} fontWeight="500" color="#545860" >
          Bills
        </Typography>

        <ToggleButtonGroup
          value={sortAmount}
          exclusive
          onChange={handleLRHChange}
          size="small"
          sx={{
            backgroundColor: "#f1f3f5",
            borderRadius: "999px",
            p: "2px",

            "& .MuiToggleButton-root": {
              textTransform: "none",
              fontWeight: 500,
              px: 2,
              color: "#6b7280",
              border: "none",
              borderRadius: 0,
              backgroundColor: "transparent",
            },

            "& .MuiToggleButton-root:first-of-type.Mui-selected": {
              color: "#1976d2",
              backgroundColor: "#e6f0ff",
              border: "1px solid #1976d2",
              borderTopLeftRadius: "999px",
              borderBottomLeftRadius: "999px",
              zIndex: 1,
            },

            "& .MuiToggleButton-root:first-of-type:not(.Mui-selected)": {
              borderRight: "1px solid #d1d5db",
            },

            "& .MuiToggleButton-root:nth-of-type(2).Mui-selected": {
              color: "#1976d2",
              backgroundColor: "#e6f0ff",
              border: "1px solid #1976d2",
              zIndex: 1,
            },

            "& .MuiToggleButton-root:nth-of-type(2):not(.Mui-selected)": {
              borderLeft: sortAmount === "high" ? "1px solid #d1d5db" : "none",
              borderRight: sortAmount === "low" ? "1px solid #d1d5db" : "none",
            },

            "& .MuiToggleButton-root:last-of-type.Mui-selected": {
              color: "#1976d2",
              backgroundColor: "#e6f0ff",
              border: "1px solid #1976d2",
              borderTopRightRadius: "999px",
              borderBottomRightRadius: "999px",
              zIndex: 1,
            },

            "& .MuiToggleButton-root:last-of-type:not(.Mui-selected)": {
              borderLeft: "1px solid #d1d5db",
            },
          }}
        >
          <ToggleButton value="low">
            Low{" "}
            <HugeiconsIcon
              icon={TradeDownIcon}
              size={18}
              style={{ marginLeft: 6, color: "red" }}
            />
          </ToggleButton>
          <ToggleButton value="recent">
            Recent{" "}
            <HugeiconsIcon
              icon={Clock01Icon}
              size={18}
              style={{ marginLeft: 6 }}
            />
          </ToggleButton>
          <ToggleButton value="high">
            High{" "}
            <HugeiconsIcon
              icon={TradeUpIcon}
              size={18}
              style={{ marginLeft: 6, color: "green" }}
            />
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      <Grid container spacing={2}>
        {displayedBills.map((bill, index) => (
          <Grid
            item
            key={index}
            xs={12}
            sm={6}
            md={4}
            lg={2}
            xl={2}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Card
              key={bill.id}
              onClick={() => handleCardClick(bill)}
              sx={{
                width: "100%",
                maxWidth: 180,
                borderRadius: 2,
                boxShadow: 3,
                overflow: "hidden",
                position: "relative",
                cursor: 'pointer',
                border: '1px solid #ccc',
                padding: '5px',
                margin: '10px 0'
              }}
            >
              {/* Agar image hai to show karo warna "No Preview Image" */}
              {bill.img ? (
                <CardMedia
                  component="img"
                  image={bill.img}
                  height="100"
                  alt="Bill"
                />
              ) : (
                <Box
                  height={100}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  sx={{ bgcolor: "#f5f5f5" }}
                >
                  <Typography variant="caption" color="text.secondary">
                    No Preview Image
                  </Typography>
                </Box>
              )}

              {/* Agar tagLabel aur tagColor hai tabhi chip show ho */}
              {bill.tagLabel && bill.tagColor && (
                <Chip
                  label={bill.tagLabel}
                  sx={{
                    position: "absolute",
                    top: 95,
                    right: 8,
                    height: 22,
                    fontSize: 12,
                    backgroundColor: bill.tagColor,
                    color: "white",
                    borderRadius: "10px",
                  }}
                />
              )}

              <CardContent sx={{ p: 1.5 }}>
                <Typography variant="body2" fontWeight="bold">
                  Bill ID: {bill.id}
                </Typography>
                <Typography variant="body2" fontWeight="bold">
                  Amount: {bill.amount}
                </Typography>
              </CardContent>
            </Card>

          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default BillDashboard;
